export const PATH_INDEX = '/';

export const PATH_ADMIN = '/admin';
export const PATH_NFT_TRANSFER = '/nft-transfer';
export const PATH_FAQ = '/faq';
